import { useState } from 'react';
import { createContext, useContextSelector } from 'use-context-selector';
import { PerkWaveStats, Results as ResultsType } from 'utils/simulate';

export type ResultContextType = {
  results: ResultsType;
  log: string[];
  setResults: Function;
  setLog: Function;
};

export const getDefaultWaveStats = (): PerkWaveStats => ({
  wave: 0,
  has: 0,
});

export const getInitialResults = (): ResultsType => ({
  count: 0,
  stats: {
    perkWaveStats: {
      gameSpeedWave: getDefaultWaveStats(),
      goldenTowerWave: getDefaultWaveStats(),
      coinBonusesWave: getDefaultWaveStats(),
      tradeoffCoinWave: getDefaultWaveStats(),
      allCoinBonuses: getDefaultWaveStats(),
      allNeededPerks: getDefaultWaveStats(),
      noMoreOptions: getDefaultWaveStats(),
      damageDamageWave: getDefaultWaveStats(),
      firstPerkReduction: getDefaultWaveStats(),
      secondPerkReduction: getDefaultWaveStats(),
      thirdPerkReduction: getDefaultWaveStats(),
    },
    finalStats: {
      basicCoinBonuses: 0,
      hpBonuses: 0,
      defenseBonuses: 0,
      extraOrbs: 0,
      perkCount: 0,
      perkMultiplier: 1,
    },
    waves: {},
  },
});

export const Results = createContext<ResultContextType>({
  results: getInitialResults(),
  log: [],
  setResults: () => {},
  setLog: () => {},
});
const { Provider } = Results;

export const ResultProvider = ({ children }) => {
  const [log, setLog] = useState<string[]>([]);
  const [results, setResults] = useState<ResultsType>(getInitialResults());
  return (
    <Provider value={{ log, setLog, results, setResults }}>{children}</Provider>
  );
};

export const useLog = () => useContextSelector(Results, ({ log }) => log);
export const useResults = () =>
  useContextSelector(Results, ({ results }) => results);
export const useSetLog = () =>
  useContextSelector(Results, ({ setLog }) => setLog);
export const useSetResults = () =>
  useContextSelector(Results, ({ setResults }) => setResults);
